module.exports = __webpack_public_path__ + "img/pcBanner16.6face4dc.png";